import React from 'react';
import { useLocale } from '../../../../contexts/LocaleContext';
import './Features.css';

const Features: React.FC = () => {
  const { t } = useLocale();

  const features = [
    {
      icon: 'fas fa-map-marked-alt',
      title: t('featureRoamr1Title'),
      description: t('featureRoamr1Description')
    },
    {
      icon: 'fas fa-suitcase-rolling',
      title: t('featureRoamr2Title'),
      description: t('featureRoamr2Description')
    },
    {
      icon: 'fas fa-file-alt',
      title: t('featureRoamr3Title'),
      description: t('featureRoamr3Description')
    },
    {
      icon: 'fas fa-share-alt',
      title: t('featureRoamr4Title'),
      description: t('featureRoamr4Description')
    },
    {
      icon: 'fas fa-sync-alt',
      title: t('featureRoamr5Title'),
      description: t('featureRoamr5Description')
    }
  ];

  return (
    <section className="features-section">
      <div className="container">
        <h2>{t('featuresRoamrTitle')}</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <i className={feature.icon}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
